import React, { useEffect, useState } from 'react'
import './datalist.scss'
import searchIcon from '../../../assets/images/icons/chevron-down.svg'

interface DatalistProps {
    name: string;
    id: string;
    options: Array<{ id: number, name: string }>;
    onChange: any;
    value: any;
}

const Datalist = (props: DatalistProps) => {

    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState(props.value || '');
    const [filteredOptions, setFilteredOptions] = useState<Array<{ id: number, name: string }>>([]);
    const [searchValue, setSearchValue] = useState('')

    useEffect(() => {
        setFilteredOptions(props.options.filter((option) => option.name.toUpperCase().includes(searchValue.toUpperCase())))
    }, [searchValue])


    const handleOpen = () => {

        if (isOpen) {
            setSearchValue('')
        }

        setIsOpen(!isOpen);
    }

    const handleOnChange = (e) => {
        setSearchValue(e.target.value)
    }

    const handleOptionClick = (option) => {
        setSearchValue('')
        setValue(option)
        setIsOpen(false);
    }

    useEffect(() => {
        props.onChange(JSON.stringify(value), props.id);
    }, [value])


    return (
        <div className="a-datalist">
            <button
                onClick={handleOpen}
                className="a-datalist__button"
            >
                {props.value?.name || 'Selecciona'}
                <img
                    src={searchIcon}
                    alt={isOpen ? 'Cerrar' : 'Abrir'}
                    className={`a-datalist__button__search-icon ${isOpen ? 'a-datalist__button__search-icon--open' : ''}`}
                />
            </button>

            {
                isOpen &&
                <div className="a-datalist__section">
                    <input
                        className="a-datalist__section__hidden"
                        type='text'
                        required
                        value={value}
                        name={props.id}
                        onChange={props.onChange}
                    ></input>
                    <input type="text" name="search" value={searchValue} placeholder="BUSCAR" onChange={handleOnChange} />
                    <div className="a-datalist__section__options">
                        {
                            filteredOptions.map((option) => (
                                <a
                                    className="a-datalist__section__options__option"
                                    onClick={() => handleOptionClick(option)}
                                    key={option.id}
                                >
                                    {option.name}
                                </a>
                            ))
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default Datalist;